module.exports = __webpack_public_path__ + "img/qconsh.8e48326b.png";